import { Roles } from '../enums/roles.enum';
import { UserManagementService } from 'src/app/services/user-management.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { User, Iuser } from '../interfaces/user';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserInfoComponent } from '../user-info/user-info.component';
import { AddUserComponent } from '../add-user/add-user.component';
import { ToastrService } from 'ngx-toastr';
import { isNullOrUndefined } from 'util';
import { Router } from '@angular/router';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
// import { AppStateService } from 'src/app/services/app-state.service';
// import Swal from 'sweetalert2';
import { EncdecService } from 'src/app/services/encdec.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { EditUserComponent } from '../edit-user/edit-user.component';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { AesEncdecService } from 'src/app/services/aes-encdec.service';
// import { AesEncdecService } from 'src/app/services/aes-encdec.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  @ViewChild('viewpassword', {}) viewpassword;
  users: User[] = [];
  searchString: string = '';
  activeSpinner = false;
  activesidetab;

  dummyForCentral = {
    "token": "eyJhbGciOiJIUzI1NiJ9.eyJzdW",
    "userDetails": {
      "firstName": "Riya CGWB",
      "lastName": "Goyal",
      "email": "1@gmail.com",
      "mobileNo": "9999999999",
      "roles": [
        "GEC_CGWB_ADMIN"
      ],
      "permissions": null,
      "userDetailsJson": {
        "stateId": null,
        "stateName": null,
        "countryId": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
        "countryName": "India",
        "locationId": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
        "locationName": "India",
        "locationType": "country",
      },
      "approver": {
        "firstName": "eswar",
        "lastName": "chakravarthi",
        "email": "geswarchakravarthi@gmail.com",
        "mobileNo": null,
        "roles": null,
        "permissions": null,
        "userDetailsJson": null,
        "approver": null,
        "passwordHash": null,
        "createdTs": null,
        "updatedTs": null,
        "deleted": null,
        "userId": null
      },
      "passwordHash": null,
      "createdTs": null,
      "updatedTs": null,
      "deleted": null,
      "userId": 5
    }
  };

  dummyForState = {
    "token": "eyJhbGciOiJIUzI1NiJ9.eyJzdW",
    "userDetails": {
      "firstName": "Riya State",
      "lastName": "Goyal",
      "email": "1@gmail.com",
      "mobileNo": "9999999999",
      "roles": [
        "GEC_STATE_ADMIN"
      ],
      "permissions": null,
      "userDetailsJson": {
        "stateId": "e7b3f02d-2497-4bcd-9e20-baa4b621822b",
        "stateName": "MAHARASHTRA",
        "countryId": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
        "countryName": "India",
        "locationId": "e7b3f02d-2497-4bcd-9e20-baa4b621822b",
        "locationName": "MAHARASHTRA",
        "locationType": "STATE",
      },
      "approver": {
        "firstName": "eswar",
        "lastName": "chakravarthi",
        "email": "geswarchakravarthi@gmail.com",
        "mobileNo": null,
        "roles": null,
        "permissions": null,
        "userDetailsJson": null,
        "approver": null,
        "passwordHash": null,
        "createdTs": null,
        "updatedTs": null,
        "deleted": null,
        "userId": null
      },
      "passwordHash": null,
      "createdTs": null,
      "updatedTs": null,
      "deleted": null,
      "userId": 1
    }
  };

  // dummyForStateForUserList = [
  // {
  // "firstName": "Riya Panipat District",
  // "lastName": "Goyal",
  // "email": "1@gmail.com",
  // "mobileNo": "9999999999",
  // "roles": [
  // "GEC_DISTRICT_ADMIN"
  // ],
  // "permissions": null,
  // "userDetailsJson": {
  // "stateId": "648a95f6-9249-4c92-8ae4-a9d93eb7c898",
  // "stateName": "HARYANA",
  // "countryId": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
  // "countryName": "India",
  // "locationId": "484ec0d1-4f41-471a-b1bc-68310211676d",
  // "locationName": "PANIPAT",
  // "locationType": "DISTRICT",
  // },
  // // "approver": {
  // // "firstName": "eswar",
  // // "lastName": "chakravarthi",
  // // "email": "geswarchakravarthi@gmail.com",
  // // "mobileNo": null,
  // // "roles": null,
  // // "permissions": null,
  // // "userDetailsJson": null,
  // // "approver": null,
  // // "passwordHash": null,
  // // "createdTs": null,
  // // "updatedTs": null,
  // // "deleted": null,
  // // "userId": null
  // // },
  // "passwordHash": null,
  // // "createdTs": null,
  // // "updatedTs": null,
  // // "deleted": null,
  // "userId": 1
  // },

  // { 
  // "firstName": "Riya Panipat Field",
  // "lastName": "Goyal",
  // "email": "1@gmail.com",
  // "mobileNo": "9999999999",
  // "roles": [
  // "GEC_FIELD_ADMIN"],
  // "permissions": null,
  // "userDetailsJson": {
  // "stateId": "648a95f6-9249-4c92-8ae4-a9d93eb7c898",
  // "stateName": "HARYANA",
  // "countryId": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
  // "countryName": "India",
  // "locationId": "484ec0d1-4f41-471a-b1bc-68310211676d",
  // "locationName": "PANIPAT",
  // "locationType": "DISTRICT",
  // },
  // // "approver": {
  // // "firstName": "eswar",
  // // "lastName": "chakravarthi",
  // // "email": "geswarchakravarthi@gmail.com",
  // // "mobileNo": null,
  // // "roles": null,
  // // "permissions": null,
  // // "userDetailsJson": null,
  // // "approver": null,
  // // "passwordHash": null,
  // // "createdTs": null,
  // // "updatedTs": null,
  // // "deleted": null,
  // // "userId": null
  // // },
  // "passwordHash": null,
  // // "createdTs": null,
  // // "updatedTs": null,
  // // "deleted": null,
  // "userId": 1
  // },

  // ];

  // dummyForCentralForUserList = [
  // {
  // "firstName": "Riya State Haryana",
  // "lastName": "Goyal",
  // "email": "1@gmail.com",
  // "mobileNo": "9999999999",
  // "roles": [
  // "GEC_STATE_ADMIN"
  // ],
  // "permissions": null,
  // "userDetailsJson": {
  // "stateId": "648a95f6-9249-4c92-8ae4-a9d93eb7c898",
  // "stateName": "HARYANA",
  // "countryId": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
  // "countryName": "India",
  // "locationId": "648a95f6-9249-4c92-8ae4-a9d93eb7c898",
  // "locationName": "HARYANA",
  // "locationType": "STATE",
  // },
  // // "approver": {
  // // "firstName": "eswar",
  // // "lastName": "chakravarthi",
  // // "email": "geswarchakravarthi@gmail.com",
  // // "mobileNo": null,
  // // "roles": null,
  // // "permissions": null,
  // // "userDetailsJson": null,
  // // "approver": null,
  // // "passwordHash": null,
  // // "createdTs": null,
  // // "updatedTs": null,
  // // "deleted": null,
  // // "userId": null
  // // },
  // "passwordHash": null,
  // // "createdTs": null,
  // // "updatedTs": null,
  // // "deleted": null,
  // "userId": 1
  // },

  // { 
  // "firstName": "Riya State Telangana",
  // "lastName": "Goyal",
  // "email": "1@gmail.com",
  // "mobileNo": "9999999999",
  // "roles": [
  // "GEC_STATE_ADMIN"],
  // "permissions": null,
  // "userDetailsJson": {
  // "stateId": "a1588b13-5700-450d-b51d-b782ed565801",
  // "stateName": "TELANGANA",
  // "countryId": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
  // "countryName": "India",
  // "locationId": "a1588b13-5700-450d-b51d-b782ed565801",
  // "locationName": "TELANGANA",
  // "locationType": "STATE",
  // },
  // // "approver": {
  // // "firstName": "eswar",
  // // "lastName": "chakravarthi",
  // // "email": "geswarchakravarthi@gmail.com",
  // // "mobileNo": null,
  // // "roles": null,
  // // "permissions": null,
  // // "userDetailsJson": null,
  // // "approver": null,
  // // "passwordHash": null,
  // // "createdTs": null,
  // // "updatedTs": null,
  // // "deleted": null,
  // // "userId": null
  // // },
  // "passwordHash": null,
  // // "createdTs": null,
  // // "updatedTs": null,
  // // "deleted": null,
  // "userId": 1
  // },

  // ];

  currentLoggedInUserInfo = {
    role: ''
  };

  isBasin: boolean = false;
  userComponentList: any[];
  originalUserComponentList: any[];
  yearDropDownList: any;
  assessmentYear: string;
  monthlist: object = { 'montharray': '' };
  monthList: any = [
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
  ];
  monthsList: any;
  modeList = [
    { key: 'monthwise', value: 'Month Wise' },
    { key: 'statewise', value: 'State Wise' }
  ]
  selectedMonth: any;
  showDrop: any;
  showtabledata: boolean;
  selectedMode: any;
  stateArrayList: any[];
  statelists: any[];
  selectedstate: any;
  logdata: any;
  sortedData: any;
  modalRef: any;
  @ViewChild('resetPassword', {}) resetPassword;
  newPsswrd: any;
  cnfPsswrd: any;
  username: any;
  showerrorpwd: boolean;
  dgcList: any;
  userPassword: any;

  constructor(
    private userService: UserManagementService,
    private modalSrv: NgbModal,
    private toastr: ToastrService,
    private route: Router,
    private authservice: AuthloginService,
    private constant: ConstantsModule,
    private utils: UtilsModule,
    private submitdataservice: SubmitdataService,
    private endecService : EncdecService,
   private aesEncDecService: AesEncdecService,
    // private appStateSrv: AppStateService
  ) { }

  ngOnInit() {
    //let userType = "GEC_CGWB_ADMIN";
    //let userType = "GEC_STATE_ADMIN";
    //this.setDummyLoginDetails(userType);
    this.navtabclick('usermanagement');
    this.getdynamicYears();
    this.monthsList = this.monthList;
    this.setCurrentMonthFullName();
    this.getstateslist();
    this.setCurrentLoggedInUserInfo();
    this.getUserList();
    //this.fetchSortedUsers();
    // let deccc = this.aesEncDecService.decrypt('tKobmxJTyu6+X57qkA2pv58QyEmPKfaxDsQjCz49Vlc=');
    // console.log("aaa decrrrrr::-",deccc);

  }
  public navtabclick(type) {
    if (type == 'logs') {
      this.selectedMode = "monthwise";
      this.showdropdown(this.selectedMode);
      this.getLogs();

    }
    if (type == this.activesidetab)
      return
    this.activesidetab = type;
  }

  getdynamicYears() {
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if (currentmonth < 3) {
      dropDownYear = (currentYear - 1) + '-' + currentYear;
    } else {
      dropDownYear = currentYear + '-' + (currentYear + 1);
    }
    this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data => {
      this.yearDropDownList = data['data'];
    }); this.assessmentYear = dropDownYear;
  }
  setCurrentMonthFullName() {
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj => {
      if (parseInt(monthObj['key']) == currentmonth + 1) {
        currentmonthObj = monthObj;
      }
    });
    this.monthlist['montharray'] = currentmonthObj['key'];
  }
  getstateslist() {
    let postdata = {};
    this.stateArrayList = [];
    this.statelists = [];
    postdata['pType'] = this.constant.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constant.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataservice.getLocationList(postdata).subscribe(data => {
      if (data) {
        this.statelists = [];
        Object.keys(data).forEach(key => {
          data[key].forEach(statelist => {
            this.statelists.push(statelist);
            this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
            // this.filterDropDownLists['GroupList'] = this.groupListForMultiDropDown(this.statelists,true);

          });
        })
      }
    });

  }

  selectOption(month) {
    this.selectedMonth = month
  }
  // setDummyLoginDetails(userType){
  // var content;
  // if(userType =='GEC_CGWB_ADMIN'){
  // content = this.dummyForCentral;
  // }else if(userType == 'GEC_STATE_ADMIN'){
  // content = this.dummyForState;
  // }
  // localStorage.setItem('ACCESS_TOKEN', content['token']);
  // localStorage.setItem('USER_INFO', JSON.stringify(this.createUserInfo(content['userDetails'])));
  // localStorage.setItem('USER_DETAILS_INFO', JSON.stringify(this.createUserDetails(content['userDetails']['userDetailsJson'])));
  // }

  public createUserInfo(userData) {
    var obj = {};
    if (userData === null) {
      return obj;
    }
    obj['firstName'] = userData['firstName'];
    obj['lastName'] = userData['lastName'];
    obj['email'] = userData['email'];
    obj['mobileNo'] = userData['mobileNo'];
    obj['roles'] = userData['roles'];
    obj['userId'] = userData['userId'];
    return obj;

  }

  public createUserDetails(data: any) {
    let obj: any = {};
    if (isNullOrUndefined(data)) {
      return obj;
    }
    for (let key in data) {
      if (key.indexOf('secondary') == -1 && key.indexOf('bbox') == -1) {
        obj[key] = data[key];
      }
    }
    return obj;
  }

  setCurrentLoggedInUserInfo() {
    this.currentLoggedInUserInfo["role"] = this.userService.getLoggedInUserRole();
    this.currentLoggedInUserInfo["userLocationDetails"] = this.userService.getLoggedInUserDetailsJson();
  }

  //With API
  async getUserList() {
    this.userComponentList = [];
    this.originalUserComponentList = [];
    this.activeSpinner = true;
    let userRole = this.userService.getLoggedInUserRole();
    // if(userRole == "GEC_STATE_ADMIN"){
    // this.isBasin = await this.userService.getStateHierarchy(this.currentLoggedInUserInfo['userLocationDetails']['locationId']);
    // }

    this.userService.getUsers().subscribe((res: any) => {
      if (!res.result.success) {
        if (res.result.status != 406 || res.result.status != 420) {
          // Swal.fire('Failure...', res.result.content, 'error');
        } if (res.result.status == 420) {
          this.authservice.logoutuserandsessionclear();
        }
      } else {
        this.getDGCList();
        this.users = res.result.content;
        this.submitdataservice.getSortedUserList().subscribe(data => {
          this.sortedData = [];
          this.sortedData.push(data);
          this.sortedData[0]['data'].forEach(userid => {
            Object.keys(this.users).forEach(user => {
              if (this.users[user]['roles'][0] != "DISTRICT_VALIDATE_MEMBER") {
                if (userid == this.users[user]['username']) {
                  let item = {};
                  item['userName'] = this.users[user]['username'];
                  item['firstName'] = this.users[user]['firstName'];
                  item['lastName'] = this.users[user]['lastName'];
                  let fname = this.users[user]['firstName'];
                  let lname = this.users[user]['lastName'];
                  item['name'] = fname + " " + lname;
                  item['role'] = this.formatUserRole(this.users[user]);
                  // .split('_').join(' ')
                  item['email'] = this.users[user]['email'];
                  item['mobileNo'] = this.users[user]['mobileNo'];
                  item['userDetailsJson'] = this.users[user]['userDetailsJson'];
                  item['password'] = this.users[user]['password'];
                  console.log("aaa passworddd", item, this.users[user]);

                  this.userComponentList.push(item);
                  this.originalUserComponentList.push(item);
                }
              }
            })
          })

        })
        // this.users = res.result.content;
        // Object.keys(this.users).forEach(user =>{
        // if(this.users[user]['roles'][0] != "DISTRICT_VALIDATE_MEMBER"){
        // let item ={};
        // item['userName'] = this.users[user]['username'];
        // let fname = this.users[user]['firstName'];
        // let lname = this.users[user]['lastName'];
        // item['name'] = fname + " " + lname;
        // item['role'] = this.users[user]['roles'][0];
        // // .split('_').join(' ')
        // item['email'] = this.users[user]['email'];
        // item['mobileNo'] = this.users[user]['mobileNo'];
        // item['stateName'] = this.users[user]['userDetailsJson']['stateName'];
        // this.userComponentList.push(item);
        // this.originalUserComponentList.push(item);
        // }
        // })
      }
      this.activeSpinner = false;
    }, (err) => {
    })
  }

  getDGCList() {
    let option: any = 'f78f615d-e270-4f93-90ac-27608e756b85';
    this.submitdataservice.getDGCsList(option).subscribe(data => {
      if (data.status) {
        this.dgcList = data['data'];
      }
    })
  }

  fetchSortedUsers() {

    this.submitdataservice.getSortedUserList().subscribe(data => {
      this.sortedData = [];
      this.sortedData.push(data);
      this.sortedData[0]['data'].forEach(arr => {
      })

    })
  }

  searchBarFilter(event) {
    const searchterm = event.target.value.toLowerCase().trim();
    this.userComponentList = this.originalUserComponentList.filter(data => {
      // data["userName"].startsWith(event.target.value)
      return Object.values(data).some(val => {
        if (typeof val === 'string') {
          return val.toLowerCase().includes(searchterm);
        }
        return false;
      });
    });
  }

  formatUserRole(user) {
    let stateID = user['userDetailsJson']['stateId'];
    let username = user['userDetailsJson']['locationName'];
    let role = user['roles'][0];
    // console.log("userr dgclist",this.dgcList); 
    // console.log("userr",user);
    if (role == "DISTRICT_GANGA_COMMITTEE") {
      if (this.dgcList[stateID].includes(username)) {
        // role = user['roles'][0];
      } else {
        role = "NON_DISTRICT_GANGA_COMMITTEE";
      }
    }
    if (user['username'] == "Ed_admin") {
      role = "SUB_ADMIN";
    }
    return role;
  }

  viewPassword(user) {
    console.log(user);
    
    // Toggle visibility
    user.passwordVisible = !user.passwordVisible;
  
    // Decrypt password
    const encrypted = user.userDetailsJson.encryptedPassword;
    const decrypted = this.aesEncDecService.decrypt(encrypted);
  
    try {
      // Handle case where decrypted string is a JSON (e.g., {"text":"nmcg"})
      const parsed = JSON.parse(decrypted);
      this.userPassword = parsed.text || decrypted;
    } catch (e) {
      // If it's plain text, just assign
      this.userPassword = decrypted;
    }
  
    // Open modal
    this.modalRef = this.modalSrv.open(this.viewpassword, {
      backdrop: 'static',
      windowClass: 'modal-dialog-centered reset-pssw'
    });
  }
  

  editUser(user) {
    const modal = this.modalSrv.open(EditUserComponent, {
      windowClass: 'edit-user'
    });
    var copyUser = Object.assign({}, user);
    copyUser.userDetailsJson = copyUser.userDetailsJson;
    modal.componentInstance.user = copyUser;
    modal.result.then((result) => {
      this.getUserList();
    }, (reason) => {
    });

  }

  getUserInfo(user) {
    const modal = this.modalSrv.open(UserInfoComponent, {
    });
    modal.componentInstance.user = user;

    // setTimeout(() => {
    // modal.dismiss();
    // }, 10000);
  }

  openChangePasswrdModal(user) {
    this.username = user.userName;
    this.modalRef = this.modalSrv.open(this.resetPassword, { backdrop: 'static', windowClass: 'modal-dialog-centered reset-pssw' });
  }

  changePassword() {
    if (this.newPsswrd) {
      if (this.newPsswrd == this.cnfPsswrd) {
        let passwordHash = this.endecService.rsaenc(this.constant.PUBLIC_KEY, this.newPsswrd + "," + this.cnfPsswrd + "," + this.constant.USER_TYPES["ADMIN"] + "," + this.username);
        this.authservice.changeUserPassword(passwordHash).subscribe(res => {
          if (res.result.success) {
            this.toastr.success(res.result.content);
            this.CloseModal();
          } else {
            this.toastr.error(res.result.content);
          }
        })
      } else {
        this.toastr.error("New password and Confirm password should be same");
      }

    } else {
      this.toastr.error("Please enter the Password");
    }
    this.newPsswrd = "";
    this.cnfPsswrd = "";
  }

  deleteUser(user) {
    let postdata = {
      "username": this.endecService.rsaenc(this.constant.PUBLIC_KEY, user.userName),
      "userInfoEncrypted": true
    }
    if (confirm("Are you sure to delete " + user.userName)) {
      this.userService.deleteUser(postdata).subscribe((res: any) => {
        if (res.result.success) {
          this.toastr.success(res.result.content);
          this.getUserList();
        } else {
          if (res.result.status != 406 || res.result.status != 420) {
            this.toastr.error(res.result.content);
            //Swal.fire('Failure...',res.result.content, 'error');
          } if (res.result.status == 420) {
            this.authservice.logoutuserandsessionclear();
          }
        }
      })
    }
  }

  changeRole(user) {

  }
  getJsonParse(string) {
    if (string === null || string === "")
      return {};
    return JSON.parse(string);
  }
  public addUser() {
    const modal = this.modalSrv.open(AddUserComponent, {

    });
    modal.result.then((result) => {
      this.getUserList();
    }, (reason) => {
    });

  }

  // isAdmins(user: Iuser) {
  // return this.appStateSrv.isAuthorized(user.roles[0], "DELETE_USER_FUNCTIONALITY");
  // }

  getLogs() {
    let postdata = {};
    postdata['ay'] = this.assessmentYear;
    postdata['subTp'] = this.monthlist['montharray'];
    if (this.showDrop == "statewise") {
      postdata['pu'] = this.selectedstate;
    }
    this.submitdataservice.getLoginDetails(postdata).subscribe(logs => {
      this.logdata = logs;
    })
  }

  showdropdown(selectedMode) {
    this.showDrop = selectedMode;
    this.showtabledata = false;
  }
  formatTmStmp(date) {
    // return date == null ? "-" : datetime.toLocalString();
    if (date == null) {
      return '-';
    }
    else {
      var datetime: any = new Date(date / 1);
      var dd = datetime.getDate();
      var mm = datetime.getMonth() + 1;
      var yyyy = datetime.getFullYear();
      var time = datetime.toLocaleTimeString();
      var fullDate = dd + '/' + mm + '/' + yyyy + ', ' + time;
      return fullDate;
    }
  }

  downloadAsPDF(type) {
    if (type == 'userslist') {
      let label = "Users List";
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      html2canvas(DATA).then(function (canvas) {
        canvas.getContext('2d');
        var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width + (top_left_margin * 2);
        var PDF_Height = (PDF_Width * 1.5) + (top_left_margin * 2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;
        var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height);

        // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        // pdf.setFontSize(30);
        // pdf.text(label, 675,27);
        // pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin+30,canvas_image_width,canvas_image_height); 

        for (var i = 1; i <= totalPDFPages; i++) {
          pdf.addPage([PDF_Width, PDF_Height]);
          let margin = -(PDF_Height * i) + (top_left_margin * 4);
          if (i > 1) {
            margin = margin + i * 8;
          }
          pdf.addImage(imgData, 'JPG', top_left_margin, margin, canvas_image_width, canvas_image_height);
        }
        pdf.save("UsersList.pdf");
      });
      this.activeSpinner = false;

    } else if (type == 'logs') {
      let label = "Logs";
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      // setTimeout(() => {
      // html2canvas(DATA).then(canvas => {
      // let fileWidth = 208;
      // let pageHeight = 200;
      // let fileHeight = canvas.height * fileWidth / canvas.width;
      // let heightLeft = fileHeight;
      // const FILEURI = canvas.toDataURL('image/png')
      // let PDF = new jsPDF('p', 'mm', [canvas.width, canvas.height]);
      // let position = 20;
      // PDF.text(label, 8, 15);
      // PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      // heightLeft -= pageHeight;

      // while(heightLeft >= 0){
      // position = heightLeft - fileHeight;
      // PDF.addPage();
      // PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      // heightLeft -= pageHeight;
      // }
      // let filename = "Logs.pdf"
      // PDF.save(filename);
      // this.activeSpinner = false;

      // });
      // }, 200);

      html2canvas(DATA).then(function (canvas) {
        canvas.getContext('2d');
        var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width + (top_left_margin * 2);
        var PDF_Height = (PDF_Width * 1.5) + (top_left_margin * 2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;
        var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height);

        // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        // pdf.setFontSize(30);
        // pdf.text(label, 675,27);
        // pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin+30,canvas_image_width,canvas_image_height); 

        for (var i = 1; i <= totalPDFPages; i++) {
          pdf.addPage([PDF_Width, PDF_Height]);
          let margin = -(PDF_Height * i) + (top_left_margin * 4);
          if (i > 1) {
            margin = margin + i * 8;
          }
          pdf.addImage(imgData, 'JPG', top_left_margin, margin, canvas_image_width, canvas_image_height);
        }
        pdf.save("Logs.pdf");
      });
      this.activeSpinner = false;
    }

  }

  pswdValidate(pswd) {
    let passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,20}$/
    if (pswd.match(passw)) {
      this.showerrorpwd = false;
    } else {
      this.showerrorpwd = true;
    }
  }

  CloseModal() {
    this.newPsswrd = "";
    this.cnfPsswrd = "";
    this.modalRef.dismiss();
  }
}